// @flow
import { DURATION, EASING } from '../constants';
import styled, { keyframes } from 'styled-components';

const revealScaling = keyframes`to { transform: scale3d(1, 1, 1); }`;
const revealOpacity = keyframes`to { opacity: 1; }`;

const Line = styled.path`
    animation: ${revealScaling} ${DURATION} ${EASING} forwards;
    opacity: 0.5;
    stroke: ${p => p.theme.heavyGrey};
    stroke-dasharray: 5 2;
    stroke-width: 2;
    transform: scale3d(1, 0, 1);
`;

export const UpperLine = styled(Line)`transform-origin: 0 100%;`;
export const LowerLine = styled(Line)`transform-origin: 0 0;`;

export const StartDot = styled.circle`
    animation: ${revealOpacity} ${DURATION} ${EASING} forwards;
    fill: ${p => p.theme.heavyGrey};
    opacity: 0;
`;

export const ScaleGroup = styled.g`
    animation: ${revealScaling} ${DURATION} ${EASING} forwards;
    animation-delay: ${DURATION};
    transform: scale3d(0, 0, 1);
`;

export const SliderElement = styled.rect`
    fill: ${p => p.theme.footerColor};
    height: ${p => p.height}px;
    width: ${p => p.width}px;
`;

export const Path = styled.path`
    fill: transparent;
    stroke: ${p => p.theme.white};
    stroke-width: 2px;
`;

export const SliderClickArea = styled.rect`
    cursor: ew-resize;
    fill: transparent;
    height: ${p => p.height}px;
    transform: ${p => (p.isDragging ? 'scale3d(4, 4, 1)' : 'scale3d(1, 1, 1)')};
    width: ${p => p.width}px;
`;

export const TimeContainer = styled.rect`
    fill: ${p => p.theme.white};
    stroke: ${p => p.theme.footerColor};
    strokewidth: 1;
`;

export const TimeLabel = styled.text`
    font-size: 1.1em;
    text-anchor: middle;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/slider/style.js